/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'trash': {
    width: 14,
    height: 18,
    viewBox: '0 0 14 18',
    data: '<g _fill="#A7AEB6" fill-rule="evenodd"><path pid="0" d="M10.5 15.375a.375.375 0 01-.75 0v-9a.374.374 0 11.75 0v9zm-2.25 0a.375.375 0 01-.75 0v-9a.374.374 0 11.75 0v9zm-2.25 0a.374.374 0 11-.75 0v-9a.374.374 0 11.75 0v9zm-2.25 0a.374.374 0 11-.75 0v-9a.374.374 0 11.75 0v9zM12.375 5.25H1.125a.374.374 0 00-.375.375v9.75A2.629 2.629 0 003.375 18h6.75a2.629 2.629 0 002.625-2.625v-9.75a.374.374 0 00-.375-.375zM13.5 3.38v.74c0 .21-.17.38-.37.38H.38A.38.38 0 010 4.12v-.74C0 2.34.84 1.5 1.88 1.5h2.01l.24-.46C4.45.4 5.09 0 5.8 0h1.9c.71 0 1.36.4 1.68 1.04l.23.46h2.02c1.03 0 1.87.84 1.87 1.88"/></g>'
  }
})
